// The customer-facing name of an edge node (a site's agent).
//
// Never the hostname: the agent re-registers with `socket.gethostname()` on every start
// (POST /edge-nodes/register overwrites `hostname`), so on the DigitalOcean demo VMs it reads as
// an internal machine name such as `aisentry-atl1-migrated-nyc3` — shared by several sites, and
// naming a cloud region. The display name lives in `custom_tags.display_name`, which only
// PUT /edge-nodes/{id} writes (heartbeat and re-registration leave it alone), and falls back to
// the title-cased edge_node_id (`foster-rd-substation` -> "Foster Rd Substation"), the rule the
// Event Trace Global tab already used.

const ID_OVERRIDES = {
  'lab-dc-prime': 'Lab DC Prime',
};

export function titleCaseEdgeNodeId(id) {
  if (!id) return '';
  if (ID_OVERRIDES[id]) return ID_OVERRIDES[id];
  return String(id)
    .split(/[-_]/)
    .filter(Boolean)
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
    .join(' ');
}

export function edgeNodeDisplayName(node, fallback = 'Unnamed site') {
  if (!node) return fallback;
  const tagged = node.custom_tags && node.custom_tags.display_name;
  if (typeof tagged === 'string' && tagged.trim()) return tagged.trim();
  return titleCaseEdgeNodeId(node.edge_node_id) || fallback;
}

export default edgeNodeDisplayName;
